export default function returnErrorView() {
    window.location.hash = "/error";
}
